import AuthRoutes from './routes'
export default AuthRoutes
